import {Component, inject, OnInit} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {AsyncPipe, DecimalPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {
  AddressType, ConsiderDocument, ConsiderDocumentStatus,
  ConsiderResultStatus,
  ErmRegMainDto,
  PettitionType,
  RegSource, AttReasonView
} from "../../../../../generated-model/model";
import {ThaiDateTimePipe} from "../../../../shared/commons/thai-datetime.pipe";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {compareWithId} from "../../../../app.constants";
import {from, Observable, shareReplay} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {IgnoreNullHttpParams} from "../../../../shared/commons/Ignore-null-http-params";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {saveAs} from "file-saver";
import {ImageViewerComponent} from "../../../../shared/commons/image-viewer/image-viewer.component";
import {PdfDialogComponent} from "../../../../shared/commons/pdf-dialog/pdf-dialog.component";
import {ConfirmDialogComponent} from "../../../../shared/commons/dialog/confirm-dialog/confirm-dialog.component";
import {ToastService} from "../../../../shared/commons/toast/toast-service";
import {environment} from "../../../../../environments/environment";
import {ConsiderDocumentResource} from "../../../../service/ConsiderDocumentResource";

@Component({
  selector: 'app-right-history-detail',
  standalone: true,
  imports: [
    FormsModule,
    NgIf,
    SharedCommonModule,
    ThaiDateTimePipe,
    NotFoundComponent,
    NgClass,
    DecimalPipe,
    AsyncPipe,
    NgForOf
  ],
  templateUrl: './right-history-detail.component.html',
  styleUrl: './right-history-detail.component.scss'
})
export class RightHistoryDetailComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private http = inject(HttpClient);
  private modalService = inject(NgbModal);
  private toastService: ToastService = inject(ToastService);
  private considerDocumentResource: ConsiderDocumentResource = inject(ConsiderDocumentResource);
  ermRegMain: ErmRegMainDto = {};
  regSource = RegSource;
  pettitionType = PettitionType;
  addressType = AddressType;
  considerResultStatus = ConsiderResultStatus;
  compareWithId = compareWithId;
  attReason: { [id: string]: Observable<AttReasonView[]> } = {
    // eform map 0--> 7 , 1 -->7
    '1': this.http.get<AttReasonView[]>(`api/att-reason/7`).pipe(shareReplay(1)),
    '2': this.http.get<AttReasonView[]>(`api/att-reason/7`).pipe(shareReplay(1)),
    '3': this.http.get<AttReasonView[]>(`api/att-reason/7`).pipe(shareReplay(1)),
    '7': this.http.get<AttReasonView[]>(`api/att-reason/7`).pipe(shareReplay(1)),
    '75': this.http.get<AttReasonView[]>(`api/att-reason/75`).pipe(shareReplay(1)),
    '76': this.http.get<AttReasonView[]>(`api/att-reason/76`).pipe(shareReplay(1)),
  }

  constructor() {
    this.activatedRoute.data.subscribe((data: { ermRegMain?: ErmRegMainDto }) => {
      this.ermRegMain = data.ermRegMain;
    });
  }

  ngOnInit(): void {
    console.log("test : " + this.ermRegMain);
  }

  back() {
    this.router.navigate(['../..'], {relativeTo: this.activatedRoute, state: {restoreSearch: true}}).then(r => r);
  }

  consider() {
    const modalRef = this.modalService.open(ConfirmDialogComponent, {centered: true});
    from(modalRef.result)
      .subscribe(e => {
        if (!!e) {
          this.http.post(`${environment.serverUrl}/api/erm-reg-main/consideration`, this.ermRegMain)
            .subscribe(value => {
              this.router.navigate(['/secure/right-history']);
              this.toastService.showSuccess("พิจารณาการลงทเบียนเรียบร้อยแล้ว");
            });
        } else {
          console.log('denied.');
        }
      }, error => error);
  }

  //สามารถจรวจสอบได้ใช่หรือไม่?
  canAudit() {
    return this.ermRegMain?.considerResult?.status == 'NEW' || this.ermRegMain?.considerResult?.status == 'REVISED_CONSIDERATION';
  }

  //พิจารณาแล้วใช่หรือไม่?
  considered() {
    return this.ermRegMain?.considerResult?.result == 'APPROVED' || this.ermRegMain?.considerResult?.result == 'NOT_APPROVED';
  }

  doAudit(item: any, status: ConsiderDocumentStatus) {
    item.status = status;
  }

  isImage(mime: string): boolean {
    return mime?.toLowerCase().startsWith("image")
  }

  isPdf(mime: string): boolean {
    return mime?.toLowerCase().includes("pdf")
  }

  showImage(file: ConsiderDocument) {
    this.considerDocumentResource.objectUrl(file, 'image').subscribe(url => {
      let modalRef = this.modalService.open(ImageViewerComponent, {size: 'xl', scrollable: true, centered: true});
      let componentInstance = modalRef.componentInstance as ImageViewerComponent;
      componentInstance.src = url;
      modalRef.hidden.subscribe(() => URL.revokeObjectURL(url));
    });
  }

  showDoc(file: ConsiderDocument) {
    this.considerDocumentResource.objectUrl(file, 'pdf').subscribe(url => {
      let modalRef = this.modalService.open(PdfDialogComponent, {size: 'xl', scrollable: true, centered: true});
      let componentInstance = modalRef.componentInstance as PdfDialogComponent;
      componentInstance.url = url;
      modalRef.hidden.subscribe(() => URL.revokeObjectURL(url));
    });
  }

  downloadDoc(file: ConsiderDocument) {
    this.considerDocumentResource.downloadDoc(file);
  }

  enableSave(): boolean {
    return this.ermRegMain.considerResult.documents.every(e => !!e.status);
  }

  reset() {
    this.ermRegMain.considerResult.documents.forEach(e => e.status = undefined);
  }
}
